module.exports = __webpack_public_path__ + "static/img/interpretive-kiosk-fiberglass-embedded-sign.abc9cdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/interpretive/interpretive-kiosk-fiberglass-embedded-sign.jpg
// module id = 1024
// module chunks = 0